export enum DealsSortBy {
    'EndingSoon' = 'EndingSoon',
    'Newest' = 'Newest',
    'MostPopular' = 'MostPopular',
    'MaxRebate' = 'MaxRebate',
    'PopularityRank' = 'PopularityRank',
    'NameAsc' = 'NameAsc',
    'NameDesc' = 'NameDesc',
}

export type DealsSortByOption = {
    label: string;
    value: DealsSortBy;
};

export const sortOptions: DealsSortByOption[] = [
    { label: 'Ending Soon', value: DealsSortBy.EndingSoon },
    { label: 'Highest Earnings', value: DealsSortBy.MaxRebate },
    { label: 'Most Popular', value: DealsSortBy.MostPopular },
    { label: 'Name (A-Z)', value: DealsSortBy.NameAsc },
    { label: 'Name (Z-A)', value: DealsSortBy.NameDesc },
    { label: 'Recently Added', value: DealsSortBy.Newest },
];

export type filterState = {
    categories: string[];
    dealTypes: string[];
    letterFilter: string;
    showPanel: '' | 'categories' | 'dealTypes';
    showSortByPanel: boolean;
    sortBy: DealsSortByOption;
    viewBonusOnly: boolean;
    panelTempOptions: {
        categories: string[];
        dealTypes: string[];
        viewBonusOnly: boolean;
    };
};

export const initialFilterState: filterState = {
    categories: [],
    dealTypes: [],
    letterFilter: '',
    showPanel: '',
    showSortByPanel: false,
    sortBy: sortOptions[2],
    viewBonusOnly: false,
    panelTempOptions: {
        categories: [],
        dealTypes: [],
        viewBonusOnly: false,
    },
};

export const dealsFilterReducer = (state: filterState, action: any) => {
    switch (action.type) {
        case 'RESET_STATE':
            return { ...initialFilterState };
        case 'SET_LETTER_FILTER':
            return { ...state, letterFilter: action.payload };
        case 'SET_SHOW_SORT_BY_PANEL':
            return { ...state, showSortByPanel: action.payload };
        case 'SET_SORT_BY':
            return { ...state, sortBy: action.payload };
        case 'SET_VIEW_BONUS_ONLY':
            return { ...state, viewBonusOnly: action.payload };
        case 'SET_SHOW_PANEL':
            if (state.showPanel === '' && action.payload !== '') {
                const previousPanelTempOptions = {
                    dealTypes: state.dealTypes?.slice() || [],
                    categories: state.categories?.slice() || [],
                    viewBonusOnly: state.viewBonusOnly,
                };
                return {
                    ...state,
                    showPanel: action.payload,
                    panelTempOptions: previousPanelTempOptions,
                };
            } else {
                return { ...state, showPanel: action.payload };
            }
        case 'REMOVE_CATEGORY':
            return {
                ...state,
                categories: state.categories.filter((c: string) => c !== action.payload),
            };
        case 'REMOVE_DEAL_TYPE':
            return {
                ...state,
                dealTypes: state.dealTypes.filter((dt: string) => dt !== action.payload),
            };
        case 'CLEAR_ALL_CATEGORIES':
            return {
                ...state,
                categories: [],
            };
        case 'CLEAR_ALL_DEAL_TYPES':
            return {
                ...state,
                dealTypes: [],
            };
        case 'UPDATE_TEMP_PANEL_OPTIONS':
            return {
                ...state,
                panelTempOptions: {
                    ...state.panelTempOptions,
                    ...action.payload,
                },
            };
        case 'CONFIRM_PANEL':
            return {
                ...state,
                dealTypes: state.panelTempOptions.dealTypes.slice(),
                categories: state.panelTempOptions.categories.slice(),
                viewBonusOnly: state.panelTempOptions.viewBonusOnly,
                showPanel: '',
                panelTempOptions: {
                    dealTypes: [],
                    categories: [],
                    viewBonusOnly: state.panelTempOptions.viewBonusOnly,
                },
            };
        case 'CANCEL_PANEL':
            return {
                ...state,
                showPanel: '',
                panelTempOptions: {
                    dealTypes: [],
                    categories: [],
                    viewBonusOnly: state.viewBonusOnly,
                },
            };
        default:
            return state;
    }
};
